import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Firestore, doc, docData } from '@angular/fire/firestore';
import { WorkoutPlan } from 'src/models/plan.model';

@Injectable({
  providedIn: 'root', // This makes the pipe available application-wide
})
@Pipe({
    name: 'planDetails',
    standalone: false
})
export class PlanDetailsPipe implements PipeTransform {
  constructor(private firestore: Firestore) {}

  transform(planId: string): Observable<WorkoutPlan> | null {
    if (!planId) {
      // Return an Observable with a default WorkoutPlan object
      const defaultWorkoutPlan: WorkoutPlan = {
        id: '',
        userId: '', // Set a default or empty value
        planName: 'New plan',
        defaultSets: 3, // Default value, adjust as needed
        exercises: [], // Empty array, assuming ExercisePlan[] can be empty
      };
      return of(defaultWorkoutPlan);
    }

    const planRef = doc(this.firestore, `workoutPlans/${planId}`);
    return docData(planRef, { idField: 'id' }) as Observable<WorkoutPlan>;
  }
}
